export default {
  entries: [],
  loadingEntries: false
}
